import React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Chip } from "@mui/material";

const PortfolioGridOCTable = () => {
  const columns = [
    { field: "id", headerName: "ID", width: 20, hide: true },
    {
      field: "buildingName",
      headerName: "Building Name",
      width: 250,
      editable: false,
    },
    {
      field: "location",
      headerName: "Location",
      width: 180,
      editable: false,
    },
    {
      field: "buildingType",
      headerName: "Building Type",
      width: 140,
      editable: false,
    },
    {
      field: "managedSpace",
      headerName: "Managed Square Footage",
      width: 120,
      editable: false,
    },
    {
      field: "occupancyRate",
      headerName: "Occupancy Rate",
      width: 120,
      editable: false,
    },
    {
      field: "avgDailyAvg",
      headerName: "Average Daily Occupancy",
      width: 120,
      editable: false,
    },
    {
      field: "peakHours",
      headerName: "Peak Hours",
      width: 180,
      editable: false,
    },
    {
      field: "spaceUtilization",
      headerName: "Maintenance Schedule Compliance",
      width: 200,
      editable: false,
    },
    {
      field: "employeeSatisfaction",
      headerName: "Employee Satisfaction (Survey Score)",
      width: 200,
      editable: false,
    },
  ];

  const rows = [
    {
      id: 1,
      buildingName: "Contoso Tower - Toronto",
      location: "Downtown Toronto, ON",
      buildingType: "Office",
      managedSpace: 150000,
      occupancyRate: "85%",
      avgDailyAvg: 425,
      peakHours: "9 AM - 5 PM",
      spaceUtilization: "High",
      employeeSatisfaction: 4.5,
    },
    {
      id: 2,
      buildingName: "Contoso Plaza - Ottawa",
      builtYear: 2015,
      location: "ByWard Market, Ottawa, ON",
      buildingType: "Mixed-Use",
      managedSpace: 120000,
      occupancyRate: "78%",
      avgDailyAvg: 312,
      peakHours: "8 AM - 6 PM",
      spaceUtilization: "Moderate",
      employeeSatisfaction: 4.7,
    },
    {
      id: 3,
      buildingName: "Contoso Residences - Vancouver",
      builtYear: 2018,
      location: "Coal Harbour, Vancouver, BC",
      buildingType: "Residential",
      managedSpace: 90000,
      occupancyRate: "90%",
      avgDailyAvg: 270,
      peakHours: "10 AM - 4 PM",
      spaceUtilization: "High",
      employeeSatisfaction: 4.3,
    },
    {
      id: 4,
      buildingName: "Contoso Innovation Hub - Calgary",
      builtYear: 2021,
      location: "Downtown Calgary, AB",
      buildingType: "Office",
      managedSpace: 200000,
      occupancyRate: "92%",
      avgDailyAvg: 414,
      peakHours: "9 AM - 5 PM",
      spaceUtilization: "High",
      employeeSatisfaction: 4.6,
    },
    {
      id: 5,
      buildingName: "Contoso Heights - Montreal",
      builtYear: 2016,
      location: "Plateau Mont-Royal, Montreal, QC",
      buildingType: "Residential",
      managedSpace: 110000,
      occupancyRate: "80%",
      avgDailyAvg: 256,
      peakHours: "8 AM - 6 PM",
      spaceUtilization: "Moderate",
      employeeSatisfaction: 4.4,
    },
    {
      id: 6,
      buildingName: "Contoso Wellness Center - Halifax",
      builtYear: 2012,
      location: "Downtown Halifax, NS",
      buildingType: "Healthcare",
      managedSpace: 95000,
      occupancyRate: "75%",
      avgDailyAvg: 450,
      peakHours: "7 AM - 7 PM",
      spaceUtilization: "Moderate",
      employeeSatisfaction: 4.2,
    },
    {
      id: 7,
      buildingName: "Contoso Retail Space - Edmonton",
      builtYear: 2019,
      location: "West Edmonton Mall, AB",
      buildingType: "Commercial",
      managedSpace: 130000,
      occupancyRate: "88%",
      avgDailyAvg: 308,
      peakHours: "8 AM - 4 PM",
      spaceUtilization: "High",
      employeeSatisfaction: 4.8,
    },
    {
      id: 8,
      buildingName: "Contoso Eco Park - Saskatoon",
      builtYear: 2020,
      location: "Meewasin Valley, Saskatoon, SK",
      buildingType: "Mixed-Use",
      managedSpace: 70000,
      occupancyRate: "82%",
      avgDailyAvg: 205,
      peakHours: "12 PM - 8 PM",
      spaceUtilization: "Moderate",
      employeeSatisfaction: 4.6,
    },
    {
      id: 9,
      buildingName: "Contoso Tower - Victoria",
      builtYear: 2014,
      location: "Downtown Victoria, BC",
      buildingType: "Office",
      managedSpace: 160000,
      occupancyRate: "87%",
      avgDailyAvg: 252,
      peakHours: "10 AM - 6 PM",
      spaceUtilization: "High",
      employeeSatisfaction: 4.7,
    },
    {
      id: 10,
      buildingName: "Contoso Conference Center - Winnipeg",
      builtYear: 2018,
      location: "The Forks, Winnipeg, MB",
      buildingType: "Event Space",
      managedSpace: 85000,
      occupancyRate: "78%",
      avgDailyAvg: 366,
      peakHours: "8 AM - 6 PM",
      spaceUtilization: "Moderate",
      employeeSatisfaction: 4.5,
    },
  ];

  return (
    <>
      <Box sx={{ height: "350px", width: "100%", overflow: "auto" }}>
        <DataGrid
          sx={{
            color: "white",
            "& .MuiDataGrid-menuIconButton": {
              color: "white",
            },
            "& .MuiCheckbox-root": {
              color: "white",
            },

            "& .MuiDataGrid-sortIcon": {
              color: "white",
            },

            "& .MuiTablePagination-root": {
              bgcolor: "white",
            },
            "& .MuiDataGrid-cell": {
              border: 0,
            },
            "& .MuiDataGrid-row:hover": {
              bgcolor: "primary.main",
            },
            "& .MuiDataGrid-cell:hover": {
              bgcolor: "none",
            },
            "& .MuiDataGrid-cell:focus": {
              bgcolor: "primary.light",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
              lineHeight: "1.5",
              whiteSpace: "normal",
            },

            "& .MuiDataGrid-cell": {
              textAlign: "center", // Centering cell content
            },
          }}
          rows={rows}
          columns={columns}
          initialState={{}}
          checkboxSelection
          disableRowSelectionOnClick
        />
      </Box>
    </>
  );
};

export default PortfolioGridOCTable;
